// MOMERY CUSTOM — Printess product form field integration.
(function () {
  if (window.__customPrintessFormFieldsInit) return;
  window.__customPrintessFormFieldsInit = true;

  const REGISTER_RETRY_INTERVAL_MS = 250;
  const REGISTER_TIMEOUT_MS = 10000;
  const PHOTOBOOK_THEME_FIELD_NAME = 'PHOTOBOOK_THEME';
  const INITIAL_PAGE_COUNT_PARAM_NAME = 'initialFreestylePhotobookPages';

  const config = window.customPrintessAppConfig || {};

  const readId = (value) => {
    if (!value) return null;
    if (typeof value.getId === 'function') return value.getId();
    if (value.id?.value !== null && value.id?.value !== undefined) return value.id.value;
    if (value.id !== null && value.id !== undefined) return value.id;
    if (value.value !== null && value.value !== undefined) return value.value;

    return null;
  };

  const normalizeId = (value) => {
    if (value === null || value === undefined) return '';

    return String(value).trim();
  };

  const getCurrentVariantId = (context) => {
    const contextVariantId = normalizeId(readId(context?.variant));
    if (contextVariantId) return contextVariantId;

    const variantInput = document.querySelector([
      'form[action*="/cart/add"] input[name="id"]:not([disabled])',
      'form[action*="/cart/add"] select[name="id"]',
      'input[name="id"]:not([disabled])',
      'select[name="id"]',
      'input[name="id"]',
    ].join(','));

    const inputVariantId = normalizeId(variantInput?.value);
    if (inputVariantId) return inputVariantId;

    return normalizeId(config.initialVariantId);
  };

  const getPhotobookTheme = (context) => {
    const variantId = getCurrentVariantId(context);
    const variantValue = config.photobookThemeByVariant?.[variantId];
    const variantTheme = variantValue === null || variantValue === undefined
      ? ''
      : String(variantValue).trim();
    if (variantTheme) return variantTheme;

    const value = config.photobookTheme;
    if (value === null || value === undefined) return '';

    return String(value).trim();
  };

  const getPageCount = (context) => {
    const variantId = getCurrentVariantId(context);
    if (!variantId) return null;

    const pageCount = Number(config.initialPageCountByVariant?.[variantId]);
    if (!Number.isInteger(pageCount) || pageCount <= 0) return null;

    return pageCount;
  };

  const getFormFieldsWithoutPhotobookTheme = (formFields) => {
    if (!Array.isArray(formFields)) return [];

    return formFields.filter((field) => field?.name !== PHOTOBOOK_THEME_FIELD_NAME);
  };

  const registerPlugin = () => {
    if (window.__customPrintessFormFieldsPluginRegistered) return true;
    if (typeof window.registerPrintessPlugin !== 'function') return false;

    window.registerPrintessPlugin({
      getFormFieldsAsync(context, formFields) {
        const nextFormFields = getFormFieldsWithoutPhotobookTheme(formFields);
        const photobookTheme = getPhotobookTheme(context);

        if (photobookTheme) {
          nextFormFields.push({
            name: PHOTOBOOK_THEME_FIELD_NAME,
            value: photobookTheme,
          });
        }

        return Promise.resolve(nextFormFields);
      },

      getAttachParametersAsync(context) {
        console.log('[CUSTOM_PRINTESS_FORM_FIELDS] getAttachParametersAsync called', {
          contextType: context?.type,
          contextVariantId: context?.variant?.getId?.() ?? null,
        });

        const pageCount = getPageCount(context);

        if (!pageCount) {
          const attachParameters = {};

          console.log('[CUSTOM_PRINTESS_FORM_FIELDS] getAttachParametersAsync return', attachParameters);

          return Promise.resolve(attachParameters);
        }

        const attachParameters = {
          bookSettings: {
            [INITIAL_PAGE_COUNT_PARAM_NAME]: pageCount,
          },
        };

        console.log('[CUSTOM_PRINTESS_FORM_FIELDS] getAttachParametersAsync return', attachParameters);

        return Promise.resolve(attachParameters);
      },
    });

    window.__customPrintessFormFieldsPluginRegistered = true;
    return true;
  };

  const waitForPluginRegistration = () => {
    if (registerPlugin()) return;

    const startedAt = Date.now();
    const retryTimer = window.setInterval(() => {
      if (registerPlugin()) {
        window.clearInterval(retryTimer);
        return;
      }

      if (Date.now() - startedAt >= REGISTER_TIMEOUT_MS) {
        window.clearInterval(retryTimer);
        console.warn('[CUSTOM_PRINTESS_FORM_FIELDS] registerPrintessPlugin is not available');
      }
    }, REGISTER_RETRY_INTERVAL_MS);
  };

  waitForPluginRegistration();
})();
